import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useContext } from "react";
import LocState from "./components/context/LocState";
import BseState from "./components/context/BseState";
import locContext from "./components/context/locContext";
import GlobalLoader from "./components/common/GlobalLoader";

// Layouts
import Navbar from "./components/layout/Navbar";
import AdminNavbar from "./components/layout/AdminNavbar";
import AdvisorNavbar from "./components/layout/AdvisorNavbar";
import Footer from "./components/layout/Footer";

// Pages
import Home from "./components/user/Home";
import About from "./components/user/About";
import Dashboard from "./components/modules/Dashboard";
import Login from "./components/auth/Login";
import MutualFund from "./components/user/MutualFund";
import Career from "./components/user/Career";
import Contact from "./components/user/Contact";
import RetirementCalculator from "./components/user/RetirementCalculator";
import SipCalculator from "./components/user/SipCalculator";
import LumpsumCalculator from "./components/user/LumpsumCalculator";
import Loan from "./components/user/Loan";
import ForgotPassword from "./components/auth/ForgotPassword";
import Registration from "./components/auth/Registration";
import UsersList from "./components/modules/users/UserList";
import MutualFunds from "./components/modules/mutualFund/MutualFunds";
import CreateMutualFund from "./components/modules/mutualFund/CreateMutualFund";
import EditMutualFund from "./components/modules/mutualFund/EditMutualFund";
import MutualFundComparison from "./components/user/MutualFundComparison";
import AdvisorRegistration from "./components/auth/AdvisorRegistration";
import ClientDashboard from "./components/client/ClientDashboard";
import ResearchAnalyst from "./components/user/Research-Analyst";
import PageUnderConstruction from "./components/user/PageUnderConstruction";
import NewInvestment from "./components/client/NewInvestment";
import FundPicks from "./components/client/FundPicks";
import AdditionalTransaction from "./components/client/AdditionalTransaction";
import MyOrders from "./components/client/MyOrders";
import ManageProfiles from "./components/client/ManageProfiles";
import RiskProfiling from "./components/client/RiskProfiling";
import RiskProfileQuestionnaire from "./components/client/RiskProfileQuestionnaire";
import Watchlist from "./components/client/Watchlist";
import InvestmentPage from "./components/user/InvestmentPage";
import InvestmentEnquiry from "./components/modules/mutualFund/InvestmentEnquiry";
import VIewInvestmentEnquiry from "./components/modules/mutualFund/VIewInvestmentEnquiry";
import Termsandconditions from "./components/user/Termsandconditions";
import PrivacyPolicy from "./components/user/PrivacyPolicy";
import RefundPolicy from "./components/user/RefundPolicy";
import OverView from "./components/client/OverView";
import ClientUccWizard from "./components/client/ClientUccWizard";
import SetGoal from "./components/client/SetGoal";
import ClientMutualFunds from "./components/client/ClientMutualFunds";
import MyInvestments from "./components/client/MyInvestments";
import Profile from "./components/client/Profile";
import LoanApplication from "./components/client/LoanApplication";

import Loan_list from "./components/modules/loan/Loan_list";
import LoanApplicationView from "./components/modules/loan/LoanApplicationView";
import GetCreatescore from "./components/client/GetCreatescore";
import TotalApplication from "./components/client/TotalApplication";
import IncomeTaxDetails from "./components/client/IncomeTaxDetails";
import GstDetails from "./components/client/GstDetails";
import BankingAnalytics from "./components/client/BankingAnalytics";
import ClientLoan from "./components/client/ClientLoan";
import ClienResearchAnalyst from "./components/client/ClienResearchAnalyst";
import PremiumSubscription from "./components/client/PremiumSubscription";
import EMICalculator from "./components/user/EMICalculator";
import LoanEligibilityEstimator from "./components/user/LoanEligibilityEstimator";
import TenureOptimizer from "./components/user/TenureOptimizer";
import ClientViewDetail from "./components/client/ClientViewDetail";
import TeamsCondition from "./components/modules/policy/TeamsCondition";
import PrivacyPolicyAd from "./components/modules/policy/PrivacyPolicyAd";
import DisclaimerAd from "./components/modules/policy/DisclaimerAd";
import Disclaimer from "./components/user/Disclaimer";
import Blog from "./components/user/Blog";
import BlogDetail from "./components/user/BlogDetail";
import BlogAd from "./components/modules/blog/BlogAd";
import CreateBlog from "./components/modules/blog/CreateBlog";
import EditBlog from "./components/modules/blog/EditBlog";
import ClientView from "./components/modules/users/ClientView";
import UccCreateScreen from "./components/modules/users/UccCreateScreen";
import UccV2DemoScreen from "./components/modules/users/UccV2DemoScreen";
import FatcaDetailsScreen from "./components/modules/users/FatcaDetailsScreen";
import CkycUploadScreen from "./components/modules/users/CkycUploadScreen";
import LumpsumPurchaseScreen from "./components/modules/users/LumpsumPurchaseScreen";
import LumpsumRedemptionScreen from "./components/modules/users/LumpsumRedemptionScreen";
import SipRegistrationScreen from "./components/modules/users/SipRegistrationScreen";
import SipCancelScreen from "./components/modules/users/SipCancelScreen";
import SipPauseResumeScreen from "./components/modules/users/SipPauseResumeScreen";
import SipToXsipShiftScreen from "./components/modules/users/SipToXsipShiftScreen";
import SipListScreen from "./components/modules/users/SipListScreen";
import SwitchOrderScreen from "./components/modules/users/SwitchOrderScreen";
import SpreadOrderScreen from "./components/modules/users/SpreadOrderScreen";
import PaymentModeSelectionScreen from "./components/modules/users/PaymentModeSelectionScreen";
import PaymentReturnScreen from "./components/modules/users/PaymentReturnScreen";
import PaymentStatusScreen from "./components/modules/users/PaymentStatusScreen";
import XsipIsipRegistrationScreen from "./components/modules/users/XsipIsipRegistrationScreen";
import MandateRegistrationScreen from "./components/modules/users/MandateRegistrationScreen";
import MandateReturnScreen from "./components/modules/users/MandateReturnScreen";
import MandateStatusScreen from "./components/modules/users/MandateStatusScreen";
import MandateShiftScreen from "./components/modules/users/MandateShiftScreen";
import MandateUploadScreen from "./components/modules/users/MandateUploadScreen";
import AofUploadScreen from "./components/modules/users/AofUploadScreen";
import ChequeUploadScreen from "./components/modules/users/ChequeUploadScreen";
import OrderStatusScreen from "./components/modules/users/OrderStatusScreen";
import ChildOrderStatusScreen from "./components/modules/users/ChildOrderStatusScreen";
import OrderRejectionScreen from "./components/modules/users/OrderRejectionScreen";
import AllotmentStatementScreen from "./components/modules/users/AllotmentStatementScreen";
import RedemptionStatementScreen from "./components/modules/users/RedemptionStatementScreen";
import Explore from "./components/client/Explore";
import FundDetails from "./components/client/FundDetails";
import LumpsumInvest from "./components/client/LumpsumInvest";
import SIPInvest from "./components/client/SIPInvest";
import Transactions from "./components/client/Transactions";
import ManageSIPs from "./components/client/ManageSIPs";
import RedeemMf from "./components/client/RedeemMf";
import SwitchMf from "./components/client/SwitchMf";
import MandatesMf from "./components/client/MandatesMf";
import PortfolioOverview from "./components/client/PortfolioOverview";
import MyFolios from "./components/client/MyFolios";
import MyAssets from "./components/client/MyAssets";
import Insurance from "./components/client/Insurance";
import Documents from "./components/client/Documents";
import InvestmentJourney from "./components/client/InvestmentJourney";
import HoldingDetails from "./components/client/HoldingDetail";
import CapitalGains from "./components/client/CapitalGains";
import AccountStatement from "./components/client/AccountStatement";
import PortfolioValuation from "./components/client/PortfolioValuation";
import PortfolioSummary from "./components/client/PortfolioSummary";
import AssetAllocation from "./components/client/AssetAllocation";
import TransactionReport from "./components/client/TransactionReport";
import CapitalGainRealized from "./components/client/CapitalGainRealized";
import CapitalGainUnrealized from "./components/client/CapitalGainUnrealized";
import DividendReport from "./components/client/DividendReport";
import ProfitLoss from "./components/client/ProfitLoss";
import PortfolioPerformance from "./components/client/PortfolioPerformance";
import PortfolioRebalancing from "./components/client/PortfolioRebalancing";
import PortfolioSnapshot from "./components/client/PortfolioSnapshot";
import ResearchHome from "./components/client/ResearchHome";
import PlansBilling from "./components/client/PlansBilling";
import CallsFeed from "./components/client/CallsFeed";
import ReportsLibrary from "./components/client/ReportsLibrary";
import ModelPortfolio from "./components/client/ModelPortfolio";
import AlertSettings from "./components/client/AlertSettings";
import TicketsList from "./components/client/TicketsList";
import TicketDetail from "./components/client/TicketDetail";
import ProfileKYC from "./components/client/ProfileKYC";
import BanksNominees from "./components/client/BanksNominees";
import Security from "./components/client/Security";
import AgentDashboard from "./components/agent/AgentDashboard";
import ClientList from "./components/modules/users/ClientList";
import OnboardClient from "./components/agent/OnboardClient";
import ClientProfile from "./components/agent/ClientProfile";
import ClientPortfolio from "./components/agent/ClientPortfolio";
import DraftOrders from "./components/agent/DraftOrders";
import FailedOrders from "./components/agent/FailedOrders";
import PlanSales from "./components/agent/PlanSales";
import ClientTickets from "./components/agent/ClientTickets";
import Commissions from "./components/agent/Commissions";

// Admin Pages
import AdminDashboard from "./components/admin/AdminDashboard";
import UserDirectory from "./components/admin/users/UserDirectory";
import KYCReviewQueue from "./components/admin/users/KYCReviewQueue";
import BankVerificationQueue from "./components/admin/users/BankVerificationQueue";
import MasterData from "./components/admin/mutual-funds/MasterData";
import OrdersMonitor from "./components/admin/mutual-funds/OrdersMonitor";
import SIPMonitor from "./components/admin/mutual-funds/SIPMonitor";
import Mandates from "./components/admin/mutual-funds/Mandates";
import Reconciliation from "./components/admin/mutual-funds/Reconciliation";
import ContentManager from "./components/admin/research/ContentManager";
import ApprovalWorkflow from "./components/admin/research/ApprovalWorkflow";
import PlansPricing from "./components/admin/research/PlansPricing";
import Subscriptions from "./components/admin/research/Subscriptions";
import InvoicesPayments from "./components/admin/billing/InvoicesPayments";
import AgentDirectory from "./components/admin/agents/AgentDirectory";
import CommissionRules from "./components/admin/agents/CommissionRules";
import TicketConsole from "./components/admin/support/TicketConsole";
import RolesPermissions from "./components/admin/security/RolesPermissions";
import AuditLogs from "./components/admin/security/AuditLogs";
import ChangePasswordScreen from "./components/modules/users/ChangePasswordScreen";
import WebsitePages from "./components/admin/cms/WebsitePages";
import WebhooksJobs from "./components/admin/integrations/WebhooksJobs";
import FolioLookup from "./components/admin/FolioLookup";
import ComprehensivePortfolio from "./components/admin/portfolio/ComprehensivePortfolio";
import InvestorDataMining from "./components/admin/portfolio/InvestorDataMining";
import ModelPortfolios from "./components/admin/portfolio/ModelPortfolios";
import NewModelPortfolio from "./components/admin/portfolio/NewModelPortfolio";
import NewClientPortfolio from "./components/admin/portfolio/NewClientPortfolio";
import Recommendations from "./components/admin/portfolio/Recommendations";           
import ProfileList from "./components/admin/invest-bse/ProfileList";
import UccList from "./components/admin/invest-bse/UccList";
import CreateUcc from "./components/admin/invest-bse/CreateUcc";
import CreateMandate from "./components/admin/invest-bse/CreateMandate";
import MandateList from "./components/admin/invest-bse/MandateList";
import MyOrdersAdmin from "./components/admin/invest-bse/MyOrders";
import RejectedUccMapping from "./components/admin/invest-bse/RejectedUccMapping";
import KycStatusReport from "./components/admin/invest-bse/KycStatusReport";
import BulkOrder from "./components/admin/invest-bse/BulkOrder";
import TransferHolding from "./components/admin/invest-bse/TransferHolding";
import SystematicOrders from "./components/admin/invest-bse/SystematicOrders";
import TransactionsView from "./components/admin/TransactionsView";
import AdminInsurance from "./components/admin/AdminInsurance";
import AdminBusinessAnalytics from "./components/admin/AdminBusinessAnalytics";
import AdminDataManagement from "./components/admin/AdminDataManagement";
import AdminEmailScheduler from "./components/admin/AdminEmailScheduler";
import AdminWhatsAppScheduler from "./components/admin/AdminWhatsAppScheduler";
import IncomeDetail from "./components/admin/brokerage/IncomeDetail";
import Analysis from "./components/admin/brokerage/Analysis";
import PayoutProcess from "./components/admin/brokerage/PayoutProcess";
import VerifyPayoutPost from "./components/admin/brokerage/VerifyPayoutPost";
import EarningRates from "./components/admin/brokerage/EarningRates";
import LostBrokerage from "./components/admin/brokerage/LostBrokerage";
import BrokerageReconciliation from "./components/admin/brokerage/BrokerageReconciliation";
import Submissions from "./components/admin/risk-profiling/Submissions";
import SetupRiskProfiler from "./components/admin/risk-profiling/SetupRiskProfiler";
import CreateClientBill from "./components/admin/billing/CreateClientBill";
import ClientBillRegister from "./components/admin/billing/ClientBillRegister";
import CreateAMCBill from "./components/admin/billing/CreateAMCBill";
import AMCBillRegister from "./components/admin/billing/AMCBillRegister";



// Role-based route guards
const PrivateRoute = ({ element }) => {
  const { userData } = useContext(locContext);
  const userRole = userData?.role_name;

  const location = useLocation();
  return userRole === "Admin"
    ? element
    : <Navigate to="/login" state={{ from: location }} replace />;
};

const PrivateRouteUser = ({ element }) => {
  const { userData } = useContext(locContext);
  const userRole = userData?.role_name;

  return userRole === "Client"
    ? element
    : <Navigate to="/login" replace />;
};

const PublicUserRoute = ({ element }) => {
  const { userData } = useContext(locContext);
  const userRole = userData?.role_name;

  // Admin should not access public/user pages like Home, About
  return userRole === "Admin"
    ? <Navigate to="/dashboard" replace />
    : element;
};

const PrivateRouteAdviser = ({ element }) => {
  const { userData } = useContext(locContext);
  const userRole = userData?.role_name;

  // Check for both "Advisor" and "Agent" role names
  const isAdvisor = userRole === "Advisor" || userRole === "Agent" || userRole?.toLowerCase() === "advisor" || userRole?.toLowerCase() === "agent";

  return isAdvisor
    ? element
    : <Navigate to="/login" replace />;
};

// Client List: allow both Admin and Advisor
const PrivateRouteAdminOrAdvisor = ({ element }) => {
  const { userData } = useContext(locContext);
  const userRole = userData?.role_name;
  const isAdmin = userRole === "Admin";
  const isAdvisor = userRole === "Advisor" || userRole === "Agent" || userRole?.toLowerCase() === "advisor" || userRole?.toLowerCase() === "agent";

  return (isAdmin || isAdvisor) ? element : <Navigate to="/login" replace />;
};

function App() {
  const location = useLocation();
  const { userData } = useContext(locContext) || {};
  const userRole = userData?.role_name || null;

  const hiddenNavRoutes = ["/registration", "/forgot-password", "/login", "/overview", "/investor-onboarding", "/clientmutualfunds", "/profile", "/ClientViewDetail", "/clientloan", "/loanapplication", "/clientresearchanalysis", "/totalapplication",
    "/incometaxdetails", "/gstdetails", "/bankinganalytics", "/Invest-application", "/AdvisorRegistration", "/explore", "/funddetails",
    "/lumpsuminvest", "/sipinvest", "/transactions", "/manageSIPs", "/redeemMf", "/switchmf", "/mandatesmf", "/portfolio-overview", "/my-folios", "/my-assets", "/insurance", "/documents", "/reports/investment-journey", "/holding-details",
    "/reports/capital-gains", "/reports/account-statement", "/research/home", "/research/plans-billing",
    "/research/calls-feed", "/research/reports-library", "/research/model-portfolio", "/research/alert-settings", "/support/tickets",
    "/support/ticket-detail", "/account/profile-kyc", "/account/banks-nominees", "/account/security",
    "/agent/dashboard", "/agent/clients", "/agent/mutual-funds", "/agent/research", "/agent/support", "/agent/earnings", "/agent/failed-orders",
    "/set-goal", "/reports/portfolio-valuation", "/reports/portfolio-summary", "/reports/asset-allocation", "/reports/transaction-report", "/reports/capital-gain-realized", "/reports/capital-gain-unrealized", "/reports/dividend-report", "/reports/profit-loss", "/reports/portfolio-performance", "/reports/portfolio-rebalancing", "/reports/portfolio-snapshot",
    "/risk-profiling", "/watchlist", "/invest-online-bse/new-investment", "/invest-online-bse/fund-picks", "/invest-online-bse/additional-transaction", "/invest-online-bse/my-orders", "/invest-online-bse/manage-profiles",
  ];
  const hiddenFooterRoutes = [
    "/client-dashboard",
    "/registration",
    "/forgot-password",
    "/dashboard",
    "/user",
    "/clientview",
    "/category",
    "/create-category",
    "/edit-category",
    "/mutualfund",
    "/create-mutualfund",
    "/edit-mutualfund",
    "/investment-enquiry",
    "/view-investment-enquiry",
    "/loan-application",
    "/loan-application-view",
    "/terms&condition",
    "/privacy-policy",
    "/disclaimer-update",
    "/bloglist",
    "/create-blog",
    "/update-blog",
    "/login",
    "/overview",
    "/investor-onboarding",
    "/clientmutualfunds",
    "/loanapplication",
    "/clientloan",
    "/totalapplication",
    "/ClientViewDetail",
    "/clientresearchanalysis",
    "/profile",
    "/incometaxdetails", "/gstdetails", "/bankinganalytics", "/Invest-application", "/AdvisorRegistration", "/explore",
    "/funddetails", "/lumpsuminvest", "/sipinvest", "/transactions", "/manageSIPs", "/holding-details", "/redeemMf", "/switchmf", "/mandatesmf", "/portfolio-overview", "/my-folios", "/my-assets", "/insurance", "/documents", "/reports/investment-journey",
    "/reports/capital-gains", "/reports/account-statement", "/research/home", "/research/plans-billing", "/research/calls-feed", "/research/reports-library", "/research/model-portfolio", "/research/alert-settings",
    "/support/tickets",
    "/support/ticket-detail", "/account/profile-kyc", "/account/banks-nominees", "/account/security",
    "/agent/dashboard", "/agent/clients", "/agent/mutual-funds", "/agent/research", "/agent/support", "/agent/earnings",
    "/admin/users/directory",
    "/admin/users/kyc-review",
    "/admin/users/bank-verification",
    "/admin/mutual-funds/master-data",
    "/admin/mutual-funds/orders-monitor",
    "/admin/mutual-funds/sip-monitor",
    "/admin/mutual-funds/mandates",
    "/admin/mutual-funds/reconciliation",
    "/admin/research/content-manager",
    "/admin/research/approval-workflow",
    "/admin/research/plans-pricing",
    "/admin/research/subscriptions",
    "/admin/billing/invoices-payments",
    "/admin/billing/create-client-bill",
    "/admin/billing/client-bill-register",
    "/admin/billing/create-amc-bill",
    "/admin/billing/amc-bill-register",
    "/admin/agents/directory",
    "/admin/agents/commission-rules",
    "/admin/support/ticket-console",
    "/admin/security/roles-permissions",
    "/admin/security/audit-logs",
    "/admin/security/change-password",
    "/admin/cms/website-pages",
    "/admin/integrations/webhooks-jobs",
    "/admin/folio-lookup",
    "/admin/portfolio/comprehensive",
    "/admin/portfolio/investor-data-mining",
    "/admin/portfolio/model",
    "/admin/portfolio/model/new",
    "/admin/portfolio/client/new",
    "/admin/portfolio/recommendations",
    "/admin/invest-bse/profile-list",
    "/admin/invest-bse/ucc-list",
    "/admin/invest-bse/create-ucc",
    "/admin/invest-bse/create-mandate",
    "/admin/invest-bse/mandate-list",
    "/admin/invest-bse/my-orders",
    "/admin/invest-bse/rejected-ucc-mapping",
    "/admin/invest-bse/kyc-status-report",
    "/admin/invest-bse/bulk-order",
    "/admin/invest-bse/transfer-holding",
    "/admin/invest-bse/systematic-orders",
    "/admin/transactions-view",
    "/admin/insurance",
    "/admin/business-analytics",
    "/admin/data-management",
    "/admin/email-scheduler",
    "/admin/whatsapp-scheduler",
    "/admin/brokerage/income-detail",
    "/admin/brokerage/analysis",
    "/admin/brokerage/payout-process",
    "/admin/brokerage/verify-payout-post",
    "/admin/brokerage/earning-rates",
    "/admin/brokerage/lost-brokerage",
    "/admin/brokerage/reconciliation",
    "/admin/risk-profiling/submissions",
    "/admin/risk-profiling/setup", "/payment/mode", "/payment/return", "/payment/status", "/user/mandate-registration", "/user/mandate-registration/:userId", "/mandate/return", "/user/mandate-status", "/user/mandate-status/:userId", "/user/mandate-shift", "/user/mandate-shift/:userId", "/user/aof-upload", "/user/aof-upload/:userId", "/user/cheque-upload", "/user/cheque-upload/:userId", "/user/order-status", "/user/order-status/:userId", "/user/child-order-status", "/user/child-order-status/:userId", "/user/order-rejection", "/user/order-rejection/:userId", "/user/allotment-statement", "/user/allotment-statement/:userId", "/user/redemption-statement", "/user/redemption-statement/:userId",,
    "/set-goal", "/client-list", "/reports/portfolio-valuation", "/reports/portfolio-summary", "/reports/asset-allocation", "/reports/transaction-report", "/reports/capital-gain-realized", "/reports/capital-gain-unrealized", "/reports/dividend-report", "/reports/profit-loss", "/reports/portfolio-performance", "/reports/portfolio-rebalancing", "/reports/portfolio-snapshot",
    "/risk-profiling", "/watchlist", "/invest-online-bse/new-investment", "/invest-online-bse/fund-picks", "/invest-online-bse/additional-transaction", "/invest-online-bse/my-orders", "/invest-online-bse/manage-profiles",
  ];

  const shouldHideNav = hiddenNavRoutes.some(route =>
    location.pathname === route || location.pathname.startsWith(route + '/')
  );
  const shouldHideFooter = hiddenFooterRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  const renderNavbar = () => {
    // Don't show navbar on auth pages (login, registration, etc.)
    if (shouldHideNav && (location.pathname === "/login" || location.pathname === "/registration" || location.pathname === "/forgot-password" || location.pathname === "/AdvisorRegistration")) {
      return null;
    }
    // Admin pages should always show AdminNavbar
    if (userRole === "Admin") {
      return <AdminNavbar />;
    }
    // For other pages, check if navbar should be hidden
    if (shouldHideNav) return null;
    return <Navbar />;
  };

  return (
    <LocState>
      <BseState>
        <GlobalLoader />
        {renderNavbar()}

        <Routes>
          {/* Public/User Only */}
          <Route path="/" element={<PublicUserRoute element={<Home />} />} />
          <Route path="/about" element={<PublicUserRoute element={<About />} />} />
          <Route path="/mutual-fund" element={<PublicUserRoute element={<MutualFund />} />} />
          <Route path="/mutual-fund-comparison" element={<PublicUserRoute element={<MutualFundComparison />} />} />
          <Route path="/career" element={<PublicUserRoute element={<Career />} />} />
          <Route path="/contact" element={<PublicUserRoute element={<Contact />} />} />
          <Route path="/RetirementCalculator" element={<PublicUserRoute element={<RetirementCalculator />} />} />
          <Route path="/SipCalculator" element={<PublicUserRoute element={<SipCalculator />} />} />
          <Route path="/LumpsumCalculator" element={<PublicUserRoute element={<LumpsumCalculator />} />} />
          <Route path="/Loan" element={<PublicUserRoute element={<Loan />} />} />
          <Route path="/research-analyst" element={<PublicUserRoute element={<ResearchAnalyst />} />} />
          <Route path="/pageunderconstruction" element={<PublicUserRoute element={<PageUnderConstruction />} />} />
          <Route path="/termsandconditions" element={<PublicUserRoute element={<Termsandconditions />} />} />
          <Route path="/privacypolicy" element={<PublicUserRoute element={<PrivacyPolicy />} />} />
          <Route path="/disclaimer" element={<PublicUserRoute element={<Disclaimer />} />} />
          <Route path="/refundpolicy" element={<PublicUserRoute element={<RefundPolicy />} />} />
          <Route path="/myinvestments" element={<PublicUserRoute element={<MyInvestments />} />} />
          <Route path="/emi-calculator" element={<PublicUserRoute element={<EMICalculator />} />} />
          <Route path="/loan-eligibility-estimator" element={<PublicUserRoute element={<LoanEligibilityEstimator />} />} />
          <Route path="/tenure-optimizer" element={<PublicUserRoute element={<TenureOptimizer />} />} />
          <Route path="/blog" element={<PublicUserRoute element={<Blog />} />} />
          <Route path="/blogdetail/:id" element={<PublicUserRoute element={<BlogDetail />} />} />


          {/* Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/AdvisorRegistration" element={<AdvisorRegistration />} />






          {/* Client */}
          <Route path="/overview" element={<PrivateRouteUser element={<OverView />} />} />
          <Route path="/investor-onboarding" element={<PrivateRouteUser element={<ClientUccWizard />} />} />
          <Route path="/set-goal" element={<PrivateRouteUser element={<SetGoal />} />} />
          <Route path="/clientmutualfunds" element={<PrivateRouteUser element={<ClientMutualFunds />} />} />
          <Route path="/client-dashboard" element={<PrivateRouteUser element={<ClientDashboard />} />} />
          <Route path="/loanapplication" element={<PrivateRouteUser element={< LoanApplication />} />} />
          <Route path="/Invest-application" element={<PrivateRouteUser element={<InvestmentPage />} />} />
          <Route path="/profile" element={<PrivateRouteUser element={<Profile />} />} />
          <Route path="/getcreatescore" element={<PrivateRouteUser element={<GetCreatescore />} />} />
          <Route path="/totalapplication" element={<PrivateRouteUser element={<TotalApplication />} />} />
          <Route path="/incometaxdetails" element={<PrivateRouteUser element={<IncomeTaxDetails />} />} />
          <Route path="/gstdetails" element={<PrivateRouteUser element={<GstDetails />} />} />
          <Route path="/bankinganalytics" element={<PrivateRouteUser element={<BankingAnalytics />} />} />
          <Route path="/clientloan" element={<PrivateRouteUser element={<ClientLoan />} />} />
          <Route path="/clientresearchanalysis" element={<PrivateRouteUser element={<ClienResearchAnalyst />} />} />
          <Route path="/premiumsubscription" element={<PrivateRouteUser element={<PremiumSubscription />} />} />
          <Route path="/ClientViewDetail" element={<PrivateRouteUser element={<ClientViewDetail />} />} />
          <Route path="/explore" element={<PrivateRouteUser element={<Explore />} />} />
          <Route path="/funddetails" element={<PrivateRouteUser element={<FundDetails />} />} />
          <Route path="/lumpsuminvest" element={<PrivateRouteUser element={<LumpsumInvest />} />} />
          <Route path="/sipinvest" element={<PrivateRouteUser element={<SIPInvest />} />} />
          <Route path="/transactions" element={<PrivateRouteUser element={<Transactions />} />} />
          <Route path="/manageSIPs" element={<PrivateRouteUser element={<ManageSIPs />} />} />
          <Route path="/redeemMf" element={<PrivateRouteUser element={<RedeemMf />} />} />
          <Route path="/switchmf" element={<PrivateRouteUser element={<SwitchMf />} />} />
          <Route path="/mandatesmf" element={<PrivateRouteUser element={<MandatesMf />} />} />
          <Route path="/portfolio-overview" element={<PrivateRouteUser element={<PortfolioOverview />} />} />
          <Route path="/my-folios" element={<PrivateRouteUser element={<MyFolios />} />} />
          <Route path="/my-assets" element={<PrivateRouteUser element={<MyAssets />} />} />
          <Route path="/insurance" element={<PrivateRouteUser element={<Insurance />} />} />
          <Route path="/documents" element={<PrivateRouteUser element={<Documents />} />} />
          <Route path="/reports/investment-journey" element={<PrivateRouteUser element={<InvestmentJourney />} />} />
          <Route path="/holding-details" element={<PrivateRouteUser element={<HoldingDetails />} />} />
          <Route path="/reports/capital-gains" element={<PrivateRouteUser element={<CapitalGains />} />} />
          <Route path="/reports/account-statement" element={<PrivateRouteUser element={<AccountStatement />} />} />
          <Route path="/reports/portfolio-valuation" element={<PrivateRouteUser element={<PortfolioValuation />} />} />
          <Route path="/reports/portfolio-summary" element={<PrivateRouteUser element={<PortfolioSummary />} />} />
          <Route path="/reports/asset-allocation" element={<PrivateRouteUser element={<AssetAllocation />} />} />
          <Route path="/reports/transaction-report" element={<PrivateRouteUser element={<TransactionReport />} />} />
          <Route path="/reports/capital-gain-realized" element={<PrivateRouteUser element={<CapitalGainRealized />} />} />
          <Route path="/reports/capital-gain-unrealized" element={<PrivateRouteUser element={<CapitalGainUnrealized />} />} />
          <Route path="/reports/dividend-report" element={<PrivateRouteUser element={<DividendReport />} />} />
          <Route path="/reports/profit-loss" element={<PrivateRouteUser element={<ProfitLoss />} />} />
          <Route path="/reports/portfolio-performance" element={<PrivateRouteUser element={<PortfolioPerformance />} />} />
          <Route path="/reports/portfolio-rebalancing" element={<PrivateRouteUser element={<PortfolioRebalancing />} />} />
          <Route path="/reports/portfolio-snapshot" element={<PrivateRouteUser element={<PortfolioSnapshot />} />} />
          <Route path="/research/home" element={<PrivateRouteUser element={<ResearchHome />} />} />
          <Route path="/research/plans-billing" element={<PrivateRouteUser element={<PlansBilling />} />} />
          <Route path="/research/calls-feed" element={<PrivateRouteUser element={<CallsFeed />} />} />
          <Route path="/research/reports-library" element={<PrivateRouteUser element={<ReportsLibrary />} />} />
          <Route path="/research/model-portfolio" element={<PrivateRouteUser element={<ModelPortfolio />} />} />
          <Route path="/research/alert-settings" element={<PrivateRouteUser element={<AlertSettings />} />} />
          <Route path="/support/tickets" element={<PrivateRouteUser element={<TicketsList />} />} />
          <Route path="/support/ticket-detail/:id" element={<PrivateRouteUser element={<TicketDetail />} />} />
          <Route path="/account/profile-kyc" element={<PrivateRouteUser element={<ProfileKYC />} />} />
          <Route path="/account/banks-nominees" element={<PrivateRouteUser element={<BanksNominees />} />} />
          <Route path="/account/security" element={<PrivateRouteUser element={<Security />} />} />
          <Route path="/risk-profiling/questionnaire" element={<PrivateRouteUser element={<RiskProfileQuestionnaire />} />} />
          <Route path="/risk-profiling" element={<PrivateRouteUser element={<RiskProfiling />} />} />
          <Route path="/watchlist" element={<PrivateRouteUser element={<Watchlist />} />} />
          <Route path="/invest-online-bse/new-investment" element={<PrivateRouteUser element={<NewInvestment />} />} />
          <Route path="/invest-online-bse/fund-picks" element={<PrivateRouteUser element={<FundPicks />} />} />
          <Route path="/invest-online-bse/additional-transaction" element={<PrivateRouteUser element={<AdditionalTransaction />} />} />
          <Route path="/invest-online-bse/my-orders" element={<PrivateRouteUser element={<MyOrders />} />} />
          <Route path="/invest-online-bse/manage-profiles" element={<PrivateRouteUser element={<ManageProfiles />} />} />

          {/* Advisor Only */}
          <Route path="/agent/dashboard" element={<PrivateRouteAdviser element={<AgentDashboard />} />} />
          <Route path="/agent/clients/onboard" element={<PrivateRouteAdviser element={<OnboardClient />} />} />
          <Route path="/agent/clients/profile" element={<PrivateRouteAdviser element={<ClientProfile />} />} />
          <Route path="/agent/mutual-funds/client-portfolio" element={<PrivateRouteAdviser element={<ClientPortfolio />} />} />
          <Route path="/agent/mutual-funds/draft-orders" element={<PrivateRouteAdviser element={<DraftOrders />} />} />
          <Route path="/agent/failed-orders" element={<PrivateRouteAdviser element={<FailedOrders />} />} />
          <Route path="/agent/research/plan-sales" element={<PrivateRouteAdviser element={<PlanSales />} />} />
          <Route path="/agent/support/client-tickets" element={<PrivateRouteAdviser element={<ClientTickets />} />} />
          <Route path="/agent/earnings/commissions" element={<PrivateRouteAdviser element={<Commissions />} />} />


          {/* Admin Only */}
          <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
          <Route path="/user" element={<PrivateRoute element={<UsersList />} />} />
          <Route path="/user/ucc/create/:userId" element={<PrivateRoute element={<UccCreateScreen />} />} />
          <Route path="/user/ucc-v2-demo" element={<PrivateRoute element={<UccV2DemoScreen />} />} />
          <Route path="/user/fatca" element={<PrivateRoute element={<FatcaDetailsScreen />} />} />
          <Route path="/user/fatca/:userId" element={<PrivateRoute element={<FatcaDetailsScreen />} />} />
          <Route path="/user/ckyc" element={<PrivateRoute element={<CkycUploadScreen />} />} />
          <Route path="/user/ckyc/:userId" element={<PrivateRoute element={<CkycUploadScreen />} />} />
          <Route path="/user/lumpsum" element={<PrivateRoute element={<LumpsumPurchaseScreen />} />} />
          <Route path="/user/lumpsum/:userId" element={<PrivateRoute element={<LumpsumPurchaseScreen />} />} />
          <Route path="/user/lumpsum-redemption" element={<PrivateRoute element={<LumpsumRedemptionScreen />} />} />
          <Route path="/user/lumpsum-redemption/:userId" element={<PrivateRoute element={<LumpsumRedemptionScreen />} />} />
          <Route path="/user/sip-registration" element={<PrivateRoute element={<SipRegistrationScreen />} />} />
          <Route path="/user/sip-registration/:userId" element={<PrivateRoute element={<SipRegistrationScreen />} />} />
          <Route path="/user/xsip-registration" element={<PrivateRoute element={<XsipIsipRegistrationScreen />} />} />
          <Route path="/user/xsip-registration/:userId" element={<PrivateRoute element={<XsipIsipRegistrationScreen />} />} />
          <Route path="/user/sip-cancel" element={<PrivateRoute element={<SipCancelScreen />} />} />
          <Route path="/user/sip-pause-resume" element={<PrivateRoute element={<SipPauseResumeScreen />} />} />
          <Route path="/user/sip-to-xsip-shift" element={<PrivateRoute element={<SipToXsipShiftScreen />} />} />
          <Route path="/user/sip-list" element={<PrivateRoute element={<SipListScreen />} />} />
          <Route path="/user/sip-list/:userId" element={<PrivateRoute element={<SipListScreen />} />} />
          <Route path="/user/switch-order" element={<PrivateRoute element={<SwitchOrderScreen />} />} />
          <Route path="/user/switch-order/:userId" element={<PrivateRoute element={<SwitchOrderScreen />} />} />
          <Route path="/user/spread-order" element={<PrivateRoute element={<SpreadOrderScreen />} />} />
          <Route path="/user/spread-order/:userId" element={<PrivateRoute element={<SpreadOrderScreen />} />} />
          <Route path="/payment/mode" element={<PrivateRoute element={<PaymentModeSelectionScreen />} />} />
          <Route path="/payment/return" element={<PrivateRoute element={<PaymentReturnScreen />} />} />
          <Route path="/payment/status" element={<PrivateRoute element={<PaymentStatusScreen />} />} />
          <Route path="/user/mandate-registration" element={<PrivateRoute element={<MandateRegistrationScreen />} />} />
          <Route path="/user/mandate-registration/:userId" element={<PrivateRoute element={<MandateRegistrationScreen />} />} />
          <Route path="/mandate/return" element={<PrivateRoute element={<MandateReturnScreen />} />} />
          <Route path="/user/mandate-status" element={<PrivateRoute element={<MandateStatusScreen />} />} />
          <Route path="/user/mandate-status/:userId" element={<PrivateRoute element={<MandateStatusScreen />} />} />
          <Route path="/user/mandate-shift" element={<PrivateRoute element={<MandateShiftScreen />} />} />
          <Route path="/user/mandate-shift/:userId" element={<PrivateRoute element={<MandateShiftScreen />} />} />
          <Route path="/user/mandate-upload" element={<PrivateRoute element={<MandateUploadScreen />} />} />
          <Route path="/user/mandate-upload/:userId" element={<PrivateRoute element={<MandateUploadScreen />} />} />
          <Route path="/user/aof-upload" element={<PrivateRoute element={<AofUploadScreen />} />} />
          <Route path="/user/aof-upload/:userId" element={<PrivateRoute element={<AofUploadScreen />} />} />
          <Route path="/user/cheque-upload" element={<PrivateRoute element={<ChequeUploadScreen />} />} />
          <Route path="/user/cheque-upload/:userId" element={<PrivateRoute element={<ChequeUploadScreen />} />} />
          <Route path="/user/order-status" element={<PrivateRoute element={<OrderStatusScreen />} />} />
          <Route path="/user/order-status/:userId" element={<PrivateRoute element={<OrderStatusScreen />} />} />
          <Route path="/user/child-order-status" element={<PrivateRoute element={<ChildOrderStatusScreen />} />} />
          <Route path="/user/child-order-status/:userId" element={<PrivateRoute element={<ChildOrderStatusScreen />} />} />
          <Route path="/user/order-rejection" element={<PrivateRoute element={<OrderRejectionScreen />} />} />
          <Route path="/user/order-rejection/:userId" element={<PrivateRoute element={<OrderRejectionScreen />} />} />
          <Route path="/user/allotment-statement" element={<PrivateRoute element={<AllotmentStatementScreen />} />} />
          <Route path="/user/allotment-statement/:userId" element={<PrivateRoute element={<AllotmentStatementScreen />} />} />
          <Route path="/user/redemption-statement" element={<PrivateRoute element={<RedemptionStatementScreen />} />} />
          <Route path="/user/redemption-statement/:userId" element={<PrivateRoute element={<RedemptionStatementScreen />} />} />
          <Route path="/clientview/:id" element={<PrivateRoute element={<ClientView />} />} />
          <Route path="/client-list" element={<PrivateRoute element={<ClientList />} />} />
          {/* <Route path="/category" element={<PrivateRoute element={<Category />} />} />
        <Route path="/create-category" element={<PrivateRoute element={<CreateCategory />} />} />
        <Route path="/edit-category/:id" element={<PrivateRoute element={<EditCategory />} />} /> */}

          <Route path="/mutualfund" element={<PrivateRoute element={<MutualFunds />} />} />
          <Route path="/create-mutualfund" element={<PrivateRoute element={<CreateMutualFund />} />} />
          <Route path="/edit-mutualfund/:id" element={<PrivateRoute element={<EditMutualFund />} />} />

          <Route path="/investment-enquiry" element={<PrivateRoute element={<InvestmentEnquiry />} />} />
          <Route path="/view-investment-enquiry/:id" element={<PrivateRoute element={<VIewInvestmentEnquiry />} />} />

          <Route path="/loan-application" element={<PrivateRoute element={<Loan_list />} />} />
          <Route path="/loan-application-view/:id" element={<PrivateRoute element={<LoanApplicationView />} />} />

          <Route path="/terms&condition-update" element={<PrivateRoute element={<TeamsCondition />} />} />
          <Route path="/privacy-policy-update" element={<PrivateRoute element={<PrivacyPolicyAd />} />} />
          <Route path="/disclaimer-update" element={<PrivateRoute element={<DisclaimerAd />} />} />

          <Route path="/bloglist" element={<PrivateRoute element={<BlogAd />} />} />
          <Route path="/create-blog" element={<PrivateRoute element={<CreateBlog />} />} />
          <Route path="/update-blog/:id" element={<PrivateRoute element={<EditBlog />} />} />

          {/* Admin Dashboard */}
          <Route path="/admin" element={<PrivateRoute element={<AdminDashboard />} />} />

          {/* Admin - Users */}
          <Route path="/admin/users/directory" element={<PrivateRoute element={<UserDirectory />} />} />
          <Route path="/admin/users/kyc-review" element={<PrivateRoute element={<KYCReviewQueue />} />} />
          <Route path="/admin/users/bank-verification" element={<PrivateRoute element={<BankVerificationQueue />} />} />

          {/* Admin - Mutual Funds */}
          <Route path="/admin/mutual-funds/master-data" element={<PrivateRoute element={<MasterData />} />} />
          <Route path="/admin/mutual-funds/orders-monitor" element={<PrivateRoute element={<OrdersMonitor />} />} />
          <Route path="/admin/mutual-funds/sip-monitor" element={<PrivateRoute element={<SIPMonitor />} />} />
          <Route path="/admin/mutual-funds/mandates" element={<PrivateRoute element={<Mandates />} />} />
          <Route path="/admin/mutual-funds/reconciliation" element={<PrivateRoute element={<Reconciliation />} />} />

          {/* Admin - Research */}
          <Route path="/admin/research/content-manager" element={<PrivateRoute element={<ContentManager />} />} />
          <Route path="/admin/research/approval-workflow" element={<PrivateRoute element={<ApprovalWorkflow />} />} />
          <Route path="/admin/research/plans-pricing" element={<PrivateRoute element={<PlansPricing />} />} />
          <Route path="/admin/research/subscriptions" element={<PrivateRoute element={<Subscriptions />} />} />

          {/* Admin - Billing */}
          <Route path="/admin/billing/invoices-payments" element={<PrivateRoute element={<InvoicesPayments />} />} />
          <Route path="/admin/billing/create-client-bill" element={<PrivateRoute element={<CreateClientBill />} />} />
          <Route path="/admin/billing/client-bill-register" element={<PrivateRoute element={<ClientBillRegister />} />} />
          <Route path="/admin/billing/create-amc-bill" element={<PrivateRoute element={<CreateAMCBill />} />} />
          <Route path="/admin/billing/amc-bill-register" element={<PrivateRoute element={<AMCBillRegister />} />} />

          {/* Admin - Agents */}
          <Route path="/admin/agents/directory" element={<PrivateRoute element={<AgentDirectory />} />} />
          <Route path="/admin/agents/commission-rules" element={<PrivateRoute element={<CommissionRules />} />} />

          {/* Admin - Support */}
          <Route path="/admin/support/ticket-console" element={<PrivateRoute element={<TicketConsole />} />} />

          {/* Admin - Security */}
          <Route path="/admin/security/roles-permissions" element={<PrivateRoute element={<RolesPermissions />} />} />
          <Route path="/admin/security/audit-logs" element={<PrivateRoute element={<AuditLogs />} />} />
          <Route path="/admin/security/change-password" element={<PrivateRoute element={<ChangePasswordScreen />} />} />

          {/* Admin - CMS */}
          <Route path="/admin/cms/website-pages" element={<PrivateRoute element={<WebsitePages />} />} />

          {/* Admin - Integrations */}
          <Route path="/admin/integrations/webhooks-jobs" element={<PrivateRoute element={<WebhooksJobs />} />} />

          {/* Admin - Folio Lookup */}
          <Route path="/admin/folio-lookup" element={<PrivateRoute element={<FolioLookup />} />} />
          <Route path="/admin/transactions-view" element={<PrivateRoute element={<TransactionsView />} />} />
          <Route path="/admin/insurance" element={<PrivateRoute element={<AdminInsurance />} />} />
          <Route path="/admin/business-analytics" element={<PrivateRoute element={<AdminBusinessAnalytics />} />} />
          <Route path="/admin/data-management" element={<PrivateRoute element={<AdminDataManagement />} />} />
          <Route path="/admin/email-scheduler" element={<PrivateRoute element={<AdminEmailScheduler />} />} />
          <Route path="/admin/whatsapp-scheduler" element={<PrivateRoute element={<AdminWhatsAppScheduler />} />} />
          <Route path="/admin/brokerage/income-detail" element={<PrivateRoute element={<IncomeDetail />} />} />
          <Route path="/admin/brokerage/analysis" element={<PrivateRoute element={<Analysis />} />} />
          <Route path="/admin/brokerage/payout-process" element={<PrivateRoute element={<PayoutProcess />} />} />
          <Route path="/admin/brokerage/verify-payout-post" element={<PrivateRoute element={<VerifyPayoutPost />} />} />
          <Route path="/admin/brokerage/earning-rates" element={<PrivateRoute element={<EarningRates />} />} />
          <Route path="/admin/brokerage/lost-brokerage" element={<PrivateRoute element={<LostBrokerage />} />} />
          <Route path="/admin/brokerage/reconciliation" element={<PrivateRoute element={<BrokerageReconciliation />} />} />
          <Route path="/admin/risk-profiling/submissions" element={<PrivateRoute element={<Submissions />} />} />
          <Route path="/admin/risk-profiling/setup" element={<PrivateRoute element={<SetupRiskProfiler />} />} />

          {/* Admin - Portfolio Management */}
          <Route path="/admin/portfolio/comprehensive" element={<PrivateRoute element={<ComprehensivePortfolio />} />} />
          <Route path="/admin/portfolio/investor-data-mining" element={<PrivateRoute element={<InvestorDataMining />} />} />
          <Route path="/admin/portfolio/model" element={<PrivateRoute element={<ModelPortfolios />} />} />
          <Route path="/admin/portfolio/model/new" element={<PrivateRoute element={<NewModelPortfolio />} />} />
          <Route path="/admin/portfolio/client/new" element={<PrivateRoute element={<NewClientPortfolio />} />} />
          <Route path="/admin/portfolio/recommendations" element={<PrivateRoute element={<Recommendations />} />} />

          {/* Admin - Invest Online BSE */}
          <Route path="/admin/invest-bse/profile-list" element={<PrivateRoute element={<ProfileList />} />} />
          <Route path="/admin/invest-bse/ucc-list" element={<PrivateRoute element={<UccList />} />} />
          <Route path="/admin/invest-bse/create-ucc" element={<PrivateRoute element={<CreateUcc />} />} />
          <Route path="/admin/invest-bse/create-mandate" element={<PrivateRoute element={<CreateMandate />} />} />
          <Route path="/admin/invest-bse/mandate-list" element={<PrivateRoute element={<MandateList />} />} />
          <Route path="/admin/invest-bse/my-orders" element={<PrivateRoute element={<MyOrdersAdmin />} />} />
          <Route path="/admin/invest-bse/rejected-ucc-mapping" element={<PrivateRoute element={<RejectedUccMapping />} />} />
          <Route path="/admin/invest-bse/kyc-status-report" element={<PrivateRoute element={<KycStatusReport />} />} />
          <Route path="/admin/invest-bse/bulk-order" element={<PrivateRoute element={<BulkOrder />} />} />
          <Route path="/admin/invest-bse/transfer-holding" element={<PrivateRoute element={<TransferHolding />} />} />
          <Route path="/admin/invest-bse/systematic-orders" element={<PrivateRoute element={<SystematicOrders />} />} />
        </Routes>

        {!shouldHideFooter && <Footer />}
      </BseState>
    </LocState>
  );
}

export default App;





